module.exports = __webpack_public_path__ + "static/media/takeoff.2ffdac24.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/takeoff.jpeg
// module id = 554
// module chunks = 4